import {
  $auditFinding,
  AuditFindingType,
  BPA_RULE_ID_PREFIX,
  FindingTypeFilterOption,
} from '../../../../../../../../shared/constants/audit-finding';
import { $auditRule } from '../../../../../../../../shared/constants/audit-rule';
import { IPopulatedManualFindingClient } from '../../../../../../../../shared/interfaces/manual-audit-finding.interface';
import { IFilterOption } from '../../../../../../components/filtering/filter.interface';

// Single source of truth for the finding type display labels (translation keys), shared by the column and the filter
export const FINDING_TYPE_LABELS: Readonly<Record<FindingTypeFilterOption, string>> = Object.freeze({
  [FindingTypeFilterOption.aiTest]: 'finding_type_ai_test',
  [FindingTypeFilterOption.cuet]: 'finding_type_cuet',
  [FindingTypeFilterOption.automated]: 'finding_type_access_engine',
  [FindingTypeFilterOption.manual]: 'finding_type_manual',
});

export const FINDING_TYPE_FILTER_OPTIONS: IFilterOption<string>[] = [
  FindingTypeFilterOption.aiTest,
  FindingTypeFilterOption.cuet,
  FindingTypeFilterOption.automated,
  FindingTypeFilterOption.manual,
].map((option: FindingTypeFilterOption) => ({ label: FINDING_TYPE_LABELS[option], value: option }));

/**
 * Client-side mirror of the server's findingType classification (ManualAuditFindingDao), used to pick the label per row.
 * The server filters; this only decides how a returned row is displayed.
 */
export function resolveFindingTypeBucket(finding: IPopulatedManualFindingClient): FindingTypeFilterOption {
  const findingType: AuditFindingType | undefined = finding[$auditFinding.findingType];
  if (findingType === AuditFindingType.cuet) {
    return FindingTypeFilterOption.cuet;
  }
  if (findingType === AuditFindingType.aiTests) {
    return FindingTypeFilterOption.aiTest;
  }
  const ruleId: unknown = finding[$auditFinding.ruleId]?.[$auditRule.ruleId];
  return typeof ruleId === 'string' && ruleId.startsWith(BPA_RULE_ID_PREFIX)
    ? FindingTypeFilterOption.automated
    : FindingTypeFilterOption.manual;
}
